export enum AuditComponent {
    Assets,
    Environments,
    ExecutionMedia,
    Processes,
    Queues,
    Robots,
    Roles,
    Schedules,
    Users,
    Comments,
    Units,
    Jobs,
    Settings,
    Packages,
    Libraries,
    License,
    Machines,
    Webhooks,
    Monitoring,
    Tasks,
    TaskCatalogs,
    Maintenance,
    CredentialStores,
    Folders,
    DirectoryService,
}

export enum AuditAction {
    Create,
    Update,
    Delete,
    Download,
    StartJob,
    StopJob,
    Associate,
    Upload,
    ChangeStatus,
    Import,
    ChangePassword,
    Toggle,
    ResetPassword,
    PasswordResetAttempt,
    Acknowledge,
    BulkUpload,
    Assign,
    Start,
    End,
    Skip,
    Unassign,
    Activate,
    Deactivate,
}

export enum HostAuditComponent {
    Tenant,
    Settings,
    Users,
    License,
    Libraries,
    Maintenance,
}

export enum HostAuditAction {
    Create,
    Update,
    Delete,
    ChangePassword,
    Register,
    PasswordResetAttempt,
    Upload,
    UpdateFeature,
    Start,
    End,
    Skip,
    Activate,
    Deactivate,
}

export interface IAuditLog {
    id: number;
    time: Date;
    serviceName: string;
    methodName: string;
    parameters: string;
    component: string;
    action: string;
    operation?: string;
    displayName: string;
    userId: number;
    userName: string;
    userType: string;
    userIsDeleted: boolean;
    entityId: number;
    data: any;
    hasDetails: boolean;
}

export interface IAuditLogDetail {
    action: string;
    entityName: string;
    entityId: number;
    customData: string;
    data: {
        value: any;
        oldValue: any;
    };
}

export interface IAuditLogFull {
    details: IAuditLogDetail[];
    log: IAuditLog;
    changes: IAuditChange[];
}

export interface IAuditChange {
    action: string;
    entityName: string;
    title: string;
    keys: string[];
    isUpdate: boolean;
    differenceMap: Record<string, boolean>;
    current: Record<string, any>;
    previous?: Record<string, any>;
}

export interface IAuditExclusionCollection {
    [component: string]: {
        [action: string]: {
            objects?: string[];
            properties?: Record<string, string[]>
        },
    };
}

export interface IAuditExclusion {
    [component: string]: {
        [action: string]: Record<string, string>,
    };
}
